import { useTheme } from '@mui/material';
import { darkTheme } from '@uiw/react-json-view/dark';
import { CSSProperties } from 'react';

/** The style @uiw/react-json-view takes: its dark palette on the dark theme, laid over the page rather than a box of its own. */
export const useJsonViewStyle = (style: CSSProperties = {}): CSSProperties => {
  const dark = useTheme().palette.mode === 'dark';
  return dark ? ({ ...darkTheme, backgroundColor: 'transparent', ...style } as CSSProperties) : style;
};

/** react-json-view's theme for react-admin-json-view; its default prints keys in a navy that vanishes on the dark theme. */
export const useReactJsonTheme = () => (useTheme().palette.mode === 'dark' ? 'monokai' : 'rjv-default');
